import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";


interface ChipProps {
    label: string,
    width: string,
    showChevron?: boolean,
    href?: string,
    onClick?: (e: any) => void
}

const Chip: React.FC<ChipProps> = ({label, width, showChevron = true, href, onClick}) => {
    const content = (
        <div className={`${width} relative flex items-center bg-[#333333] rounded-full py-1.5 pl-3`}>
      <span className="text-white font-medium text-[15px] leading-[24px]">
        {label}
      </span>
            {showChevron && (
                <div className="relative flex items-center justify-center w-4 h-4 ml-2 mr-2">
                    <img src="/images/ChevronDown.svg" alt="Chevron" className="w-4 h-4"/>
                </div>
            )}
        </div>
    );

    // Если задан href, оборачиваем контент в ссылку
    if (href) {
        return (
            <Link to={href} className="flex" onClick={onClick}>
                {content}
            </Link>
        );
    }

    return content;
};

const ChipsContainer: React.FC = () => {
    const {t} = useTranslation();

    const navigate = useNavigate()

    const handleSmoothScroll = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        targetId: string
    ) => {
        event.preventDefault();

        if (window.location.pathname === "/landing") {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        } else {
            navigate("/landing", {state: {targetId}});
        }
    };

    return (
        <div className="flex flex-row justify-center items-center gap-3 mx-auto h-[36px] ">
            <Chip label={t("header.chip_1")} width="w-auto" href="#OurPlus" onClick={(e) => handleSmoothScroll(e, "OurPlus")}/>
            <Chip label={t("header.chip_2")} width="w-auto" href="#Feature" onClick={(e) => handleSmoothScroll(e, "Feature")}/>
            <Chip label={t("header.chip_3")} width="w-auto" href="#WhyUs" onClick={(e) => handleSmoothScroll(e, "WhyUs")}/>
            <Chip label={t("header.chip_4")} width="w-auto" href="#Case" onClick={(e) => handleSmoothScroll(e, "Case")}/>
            <Chip label={t("header.chip_5")} width="w-auto" href="#pricing" onClick={(e) => handleSmoothScroll(e, "pricing")}/>
            <Chip label={t("header.chip_6")} width="w-auto" href="#FAQ" onClick={(e) => handleSmoothScroll(e, "FAQ")}/>
        </div>
    );
};

export default ChipsContainer;
